export const apiUrl = "https://api01.qrcodies.com"
